import { api } from './_httpClient'

const list = async () => api.get('/course/list')
const listAuth = async () => api.get('/course/list/auth')

export { list, listAuth }
